import React from 'react';
import { Badge } from '../ui/badge';
import { Handshake, ExternalLink } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const PARTNERS = [
  {
    id: 'imef',
    name: 'IMEF',
    fullName: 'Instituto Mexicano de Ejecutivos de Finanzas',
    url: 'https://www.imef.org.mx/',
    logo:
      'https://customer-assets.emergentagent.com/job_d4b3d2e1-67da-40cf-8efa-61dbe3f79433/artifacts/mc0navb1_logo%20imef.png',
    bgClass: 'bg-white',
  },
  {
    id: 'fintech-mexico',
    name: 'Fintech México',
    fullName: 'Asociación Fintech México',
    url: 'https://www.fintechmexico.org/',
    logo:
      'https://customer-assets.emergentagent.com/job_d4b3d2e1-67da-40cf-8efa-61dbe3f79433/artifacts/8hor688s_images%20%286%29.png',
    bgClass: 'bg-white',
  },
  {
    id: 'aleccc',
    name: 'ALECCC',
    fullName: 'Asociación Latinoamericana de Empresas de Cobranza y Contact Centers',
    url: 'https://www.aleccc-lat.org/',
    logo:
      'https://customer-assets.emergentagent.com/job_d4b3d2e1-67da-40cf-8efa-61dbe3f79433/artifacts/ceo9cuax_6994bb795234ab0514be1cda_Aleccc%20logo.png',
    bgClass: 'bg-white',
  },
];

/**
 * Strategic Partners (Aliados Estratégicos) section.
 * Displays alliance logos with links to each partner organization.
 * Used across LandingPage, RegistroPage and Community pages.
 */
export const PartnersSection = () => {
  const { language } = useLanguage();
  const isES = language === 'es';

  return (
    <section
      id="aliados"
      className="py-10 md:py-12 bg-white border-t border-gray-100"
      data-testid="partners-section"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-gray-500 font-semibold">
            <Handshake className="w-3.5 h-3.5 text-[#D4AF37]" />
            Partners
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {PARTNERS.map((partner) => (
            <a
              key={partner.id}
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`partner-card-${partner.id}`}
              aria-label={`${partner.fullName} — ${isES ? 'sitio oficial' : 'official site'}`}
              className="group inline-flex items-center justify-center px-5 py-3 rounded-xl bg-white border border-gray-200 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37]/60"
              title={`${partner.fullName} — ${isES ? 'Visitar sitio oficial' : 'Visit official site'}`}
            >
              <div className={`flex items-center justify-center rounded-md px-3 py-2 ${partner.bgClass}`}>
                <img
                  src={partner.logo}
                  alt={partner.name}
                  loading="lazy"
                  className="h-9 md:h-10 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
                />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
